import React, { createContext } from 'react';
export const DayMapContext = createContext(null);
function DayMapProvider({
  children,
  dayMap = {},
  renderDayFn = () => null
}) {
  const context = {
    dayMap,
    renderDayFn
  };
  return React.createElement(DayMapContext.Provider, {
    value: context
  }, children);
}
export default DayMapProvider;